import Vue from "vue";
import { Component } from "vue-property-decorator";
import {
    NotificationStockage,
    UserInfos,
} from "@/components";

@Component({
    name: "sidebar",
    components: {
        "userinfos": UserInfos,
        "notification-stockage": NotificationStockage,
    },
})

export default class SidebarStockage extends Vue {

    public collapsed: boolean;

    public get notifications(): string[] {
        return this.$store.state.productionLines.notifications;
    }

    constructor() {
        super();

        this.collapsed = true;
    }

    public toggleCollapsed(): void {
        this.collapsed = this.collapsed ? false : true;
    }

    public deleteNotification(index: number): void {
        this.$store.dispatch("productionLines/deleteNotification", index);
    }
}
